import { useAuthStore } from '@/stores/authStore';
import { Group, Text, Menu, rem, ActionIcon, Flex } from '@mantine/core';
import UserAvatar from '../UserAvatars/UserAvatar';
import { Link, useNavigate } from 'react-router-dom';
import { useLogout } from '@/features/auth/services/useAuthQueries';
import { NAVBAR_WIDTH } from '@/common/constants/constants';
import { useState } from 'react';
import NotificationButton from '@/features/notification/components/NotificationButton';
import { IconDotsVertical } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import LaikaButton from '@/features/ai/components/LaikaButton';

export default function Header() {
    const { t } = useTranslation();
    const { user } = useAuthStore();
    const { mutate: logout } = useLogout();
    const navigate = useNavigate();

    const [isHovered, setIsHovered] = useState(false);

    // 로그아웃 처리
    const handleLogout = () => {
        void logout();
        void navigate('/auth/login');
    };

    return (
        // header bottom padding은 main body의 top margin으로 적용
        <header style={{ padding: '8px 8px 0px 8px' }}>
            {/* 사용자 프로필 및 메뉴 */}
            <Group justify="space-between" w="full">
                <Group
                    justify="space-between"
                    w={{ base: 'auto', sm: NAVBAR_WIDTH + 168 }}
                    p={8}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <Group gap={4} flex={1}>
                        <UserAvatar name={user?.name} imageUrl={user?.profile_image_url} />
                        <Text flex={1} fz="xs" fw={600} lineClamp={1}>
                            {user?.name}
                        </Text>
                    </Group>
                    {isHovered && (
                        <Menu>
                            <Menu.Target>
                                <ActionIcon
                                    variant="subtle"
                                    size="xs"
                                    color="gray"
                                >
                                    <IconDotsVertical />
                                </ActionIcon>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Item
                                    component={Link}
                                    to="/auth/setting"
                                    fz="xs"
                                >
                                    {t('setting.profile')}
                                </Menu.Item>
                                <Menu.Item onClick={handleLogout} fz="xs">
                                    {t('logout')}
                                </Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                    )}
                </Group>
                <Flex px="sm" align="center" gap="sm">
                    <LaikaButton />
                    <NotificationButton />
                </Flex>
            </Group>
        </header>
    );
}
